(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9547],{

/***/ 79547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "BlogFeatured": function() { return /* binding */ BlogFeatured; },
  "default": function() { return /* binding */ blog_featured; }
});

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(91655);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./_modules/skeleton/blog_grid.jsx



var SkeletonBlogGrid = function SkeletonBlogGrid() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
    container: true,
    spacing: 2,
    alignItems: "center",
    children: [1, 2, 3, 4, 5, 6, 7, 8].map(function (item, i) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        sm: 12,
        md: 3,
        lg: 3,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
          variant: "rectangular",
          width: "100%",
          height: 220
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
          variant: "rectangular",
          width: "100%",
          height: 20,
          sx: {
            margin: "10px 0px 10px 0px"
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
          variant: "rectangular",
          width: "100%",
          height: 20,
          sx: {
            margin: "10px 0px 20px 0px"
          }
        })]
      }, i);
    })
  });
};
/* harmony default export */ var blog_grid = (SkeletonBlogGrid);
// EXTERNAL MODULE: ./_redux/blog/blogApi/blogApi.js
var blogApi = __webpack_require__(93152);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./_modules/study/blog/components/blog_grid_box/index.jsx
var blog_grid_box = __webpack_require__(27890);
// EXTERNAL MODULE: ./_modules/study/blog/blog_home/blog_featured.module.scss
var blog_featured_module = __webpack_require__(52479);
var blog_featured_module_default = /*#__PURE__*/__webpack_require__.n(blog_featured_module);
;// CONCATENATED MODULE: ./_modules/study/blog/blog_home/blog_featured.jsx







var BlogFeatured = function BlogFeatured() {
  var _useGetFeaturedBlogQu = (0,blogApi/* useGetFeaturedBlogQuery */.N6)(),
      data = _useGetFeaturedBlogQu.data,
      loading = _useGetFeaturedBlogQu.isLoading,
      error = _useGetFeaturedBlogQu.error;

  var posts = data === null || data === void 0 ? void 0 : data.data;
  var content;

  if (loading) {
    content = /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(blog_grid, {})
    });
  }

  if (!loading && error) {
    content = {
      error: error
    };
  }

  if (!error && !loading) {
    content = /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: (posts === null || posts === void 0 ? void 0 : posts.length) > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (blog_featured_module_default()).blog_hero_wrapper,
        children: posts === null || posts === void 0 ? void 0 : posts.map(function (post, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(blog_grid_box/* default */.Z, {
            post: post,
            spanTwoWithOverlay: posts.length > 1 && i === 0,
            blogTitle: post === null || post === void 0 ? void 0 : post.title,
            blogLink: "/blog/".concat(post === null || post === void 0 ? void 0 : post.slug),
            categories: post === null || post === void 0 ? void 0 : post.categories,
            featureImage: post === null || post === void 0 ? void 0 : post.image,
            videoType: post === null || post === void 0 ? void 0 : post.videoType,
            summary: post === null || post === void 0 ? void 0 : post.summary
          }, i);
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: "Data not found"
        })
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: (blog_featured_module_default()).section_blog_hero,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (blog_featured_module_default()).wrapper,
          children: content
        })
      })
    })
  });
};
/* harmony default export */ var blog_featured = (BlogFeatured);

/***/ }),

/***/ 27890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72145);
/* harmony import */ var _modules_study_common_play_btn_with_ripple__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42422);
/* harmony import */ var _blog_box_grid_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96615);
/* harmony import */ var _blog_box_grid_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_blog_box_grid_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);










var BlogBoxGrid = function BlogBoxGrid(_ref) {
  var spanTwoWithOverlay = _ref.spanTwoWithOverlay,
      colorWhite = _ref.colorWhite,
      blogTitle = _ref.blogTitle,
      blogLink = _ref.blogLink,
      categories = _ref.categories,
      featureImage = _ref.featureImage,
      videoType = _ref.videoType,
      summary = _ref.summary;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
    className: "".concat((_blog_box_grid_module_scss__WEBPACK_IMPORTED_MODULE_6___default().box_grid), " ").concat(spanTwoWithOverlay ? "".concat((_blog_box_grid_module_scss__WEBPACK_IMPORTED_MODULE_6___default().span_two_with_overlay)) : "", " "),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
      className: "".concat((_blog_box_grid_module_scss__WEBPACK_IMPORTED_MODULE_6___default().image_wrapper), " relative"),
      children: [videoType && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        legacyBehavior: true,
        href: blogLink,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_modules_study_common_play_btn_with_ripple__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            medium: !spanTwoWithOverlay,
            ripple: false
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: blogLink || "#",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
          blurDataURL: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getAssets */ .Vh)("assets/images/image_placeholder_big.webp"),
          placeholder: "blur",
          src: featureImage || (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getAssets */ .Vh)("assets/images/image_placeholder_big.webp"),
          alt: blogTitle,
          width: 800,
          height: 500
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
      className: (_blog_box_grid_module_scss__WEBPACK_IMPORTED_MODULE_6___default().blog_info),
      children: [categories && (categories === null || categories === void 0 ? void 0 : categories.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        className: (_blog_box_grid_module_scss__WEBPACK_IMPORTED_MODULE_6___default().category),
        children: categories === null || categories === void 0 ? void 0 : categories.map(function (cat, i, row) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            legacyBehavior: true,
            href: "/blog/category/".concat(cat === null || cat === void 0 ? void 0 : cat.slug),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("a", {
              className: (_blog_box_grid_module_scss__WEBPACK_IMPORTED_MODULE_6___default().blog_cat_title),
              children: [cat === null || cat === void 0 ? void 0 : cat.title, row.length === ++i ? null : ", "]
            })
          }, "cat".concat(i));
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        legacyBehavior: true,
        href: blogLink || "#",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
          style: {
            display: "block"
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h3", {
            className: "".concat((_blog_box_grid_module_scss__WEBPACK_IMPORTED_MODULE_6___default().blog_title), " ").concat(colorWhite ? "".concat((_blog_box_grid_module_scss__WEBPACK_IMPORTED_MODULE_6___default().color_white)) : "", " "),
            children: blogTitle
          })
        })
      }), summary && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
        children: spanTwoWithOverlay && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
          className: (_blog_box_grid_module_scss__WEBPACK_IMPORTED_MODULE_6___default().blog_description),
          children: summary
        })
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (BlogBoxGrid);

/***/ }),

/***/ 42422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ PlayButtonWithRipple; }
/* harmony export */ });
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30890);
/* harmony import */ var _play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["colorOrange", "medium", "ripple", "small"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var PlayButtonWithRipple = function PlayButtonWithRipple(_ref) {
  var colorOrange = _ref.colorOrange,
      medium = _ref.medium,
      _ref$ripple = _ref.ripple,
      ripple = _ref$ripple === void 0 ? true : _ref$ripple,
      small = _ref.small,
      props = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", _objectSpread(_objectSpread({
    className: "".concat((_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().play_btn), " ").concat(colorOrange ? "".concat((_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().orange)) : "", " ").concat(medium ? "".concat((_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().medium)) : "", " ").concat(small ? "".concat((_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().small)) : "")
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: (_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().arrow_right)
    }), ripple && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
      className: (_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().ripple_effect)
    })]
  }));
};
/* harmony default export */ __webpack_exports__["Z"] = (PlayButtonWithRipple);

/***/ }),

/***/ 52479:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"blog_featured___next__kJ22K","section_blog_hero":"blog_featured_section_blog_hero__DBY3m","title":"blog_featured_title__npX1z","blog_hero_wrapper":"blog_featured_blog_hero_wrapper__iVOQj"};

/***/ }),

/***/ 96615:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"blog_box_grid___next__4_7eN","box_grid":"blog_box_grid_box_grid__YVetP","blog_title":"blog_box_grid_blog_title__MH6gN","image_wrapper":"blog_box_grid_image_wrapper__4yWy3","video_popup":"blog_box_grid_video_popup__33tnX","blog_info":"blog_box_grid_blog_info__sxxqz","category":"blog_box_grid_category__vG7qN","blog_cat_title":"blog_box_grid_blog_cat_title__yunve","color_white":"blog_box_grid_color_white__Hg9BK","span_two_with_overlay":"blog_box_grid_span_two_with_overlay__AbnHS","blog_description":"blog_box_grid_blog_description__o5Ei8"};

/***/ }),

/***/ 30890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"play_btn":"play_btn_with_ripple_play_btn__yNA0_","arrow_right":"play_btn_with_ripple_arrow_right__Fmzao","ripple_effect":"play_btn_with_ripple_ripple_effect__4Jxcn","ModalRipple":"play_btn_with_ripple_ModalRipple__5yAi9","medium":"play_btn_with_ripple_medium__ClXl0","small":"play_btn_with_ripple_small__EszEQ","orange":"play_btn_with_ripple_orange__1q96e"};

/***/ })

}]);